var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.template,_vm._g(_vm._b({tag:"component",class:[
    { '--no-padding-bottom': _vm.noPaddingBottom || _vm.isCypress() },
    'app-page'
  ]},'component',_vm.props,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }